/**
 * Ticket cost coding (#1064, Ayrical ADR 0021): a ticket's business line IS
 * the QuickBooks Class (same fully qualified names; one list) and its work
 * location IS the QuickBooks Location. The server derives both at ticket
 * create; only office roles change them (PUT /tickets/:ticketId/cost-coding).
 *
 * KEEP IN SYNC with backend/src/utils/cost-coding.js and the CHECKs in
 * supabase/migrations/20261104140000_ticket_business_line_location.sql
 * (backend/__tests__/cost-coding-parity.test.js fails on drift).
 */
export const BUSINESS_LINES = [
    'Starlink',
    'Field Services:Break-fix',
    'Field Services:Projects',
    'Overhead',
];
export const WORK_LOCATIONS = [
    'Carlsbad',
    'Weatherford',
    'Wyoming',
    'Admin / Shared',
];
/** Work done outside a shop. */
export const DEFAULT_WORK_LOCATION = 'Admin / Shared';
export function isBusinessLine(value) {
    return typeof value === 'string' && BUSINESS_LINES.includes(value);
}
export function isWorkLocation(value) {
    return typeof value === 'string' && WORK_LOCATIONS.includes(value);
}
//# sourceMappingURL=cost-coding.js.map